/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { AssetPageFragmentDoc } from "./fragments.service.graphql-gen";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetAssetsQueryVariables = Types.Exact<{
	input?: Types.InputMaybe<Types.AssetsListInput>;
	period?: Types.InputMaybe<Types.TimePeriod>;
	pageSize?: Types.InputMaybe<Types.Scalars["Int"]>;
	after?: Types.InputMaybe<Types.Scalars["String"]>;
	includeOHLC: Types.Scalars["Boolean"];
	includeMaximumLeverage: Types.Scalars["Boolean"];
}>;

export type GetAssetsQuery = {
	__typename?: "Query";
	assets?: {
		__typename?: "AssetConnection";
		pageInfo?: {
			__typename?: "PageInfo";
			hasNextPage: boolean;
			hasPreviousPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		} | null;
		edges?: Array<{
			__typename?: "AssetEdge";
			cursor?: string | null;
			node?:
				| { __typename?: "CommodityAsset" }
				| {
						__typename?: "CryptoAsset";
						marketCap?: { value: string; precision: number } | null;
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						staking?: {
							__typename?: "Staking";
							estimatedRewards: { value: string; precision: number };
						} | null;
						marginLongSettings?: {
							__typename?: "AssetMarginSettings";
							maximumLeverage?: number | null;
							buyActive?: boolean | null;
							sellActive?: boolean | null;
							automatedOrderEnabled?: boolean | null;
						} | null;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
						logos: Array<{
							__typename?: "Image";
							height: number;
							mimeType: string;
							theme?: Types.UiTheme | null;
							url: string;
							width: number;
						}>;
				  }
				| { __typename?: "EquityComplexEtfAsset" }
				| { __typename?: "EquityEtcAsset" }
				| { __typename?: "EquityEtfAsset" }
				| { __typename?: "EquityRightAsset" }
				| { __typename?: "EquityStockAsset" }
				| { __typename?: "EtfAsset" }
				| { __typename?: "GenericAsset" }
				| { __typename?: "IndexAsset" }
				| { __typename?: "LeverageAsset" }
				| { __typename?: "MetalAsset" }
				| { __typename?: "SecurityTokenAsset" }
				| { __typename?: "StockAsset" }
				| null;
		} | null> | null;
		facets?: Array<
			| { __typename?: "AssetCategoryFacet" }
			| {
					__typename?: "MarginMaximumLeverageFacet";
					field?: string | null;
					values?: Array<{
						__typename?: "MarginMaximumLeverageFacetValue";
						key: string;
						count?: number | null;
						value: number;
					}> | null;
			  }
			| { __typename?: "TransactionFacet" }
		> | null;
	} | null;
};

export const GetAssetsDocument = gql`
	query GetAssets(
		$input: AssetsListInput
		$period: TimePeriod
		$pageSize: Int
		$after: String
		$includeOHLC: Boolean!
		$includeMaximumLeverage: Boolean!
	) {
		assets(input: $input, first: $pageSize, after: $after) {
			...AssetPage
		}
	}
	${AssetPageFragmentDoc}
`;

@Injectable({
	providedIn: "root"
})
export class GetAssetsGQLService extends Apollo.Query<GetAssetsQuery, GetAssetsQueryVariables> {
	document = GetAssetsDocument;
	client = "bff";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
